<template>
    <div class="sub-head">
        <div v-bind="{ subVisualAttrs }" :class="subVisualAttrs.class" class="sub-visual">
            <div class="sub-visual__inner">
                <v-container v-if="this.$slots['tit']">
                    <slot name="tit" />
                </v-container>
            </div>
            <div class="sub-visual__bg" :style="'background-image:url(' + bg + ');'"></div>
        </div>

        <gnb v-bind="{ itemTitle, tabsTag, tabsAttrs, tabTag, tabAttrs, tabActive }" gnbName="sub-tab" />
        <slot />
    </div>
</template>

<script>
import Gnb from "@/components/publish/styles/headers/gnb.vue";

export default {
    props: {
        title: String,
        bg: String,
        subVisualAttrs: { type: Object, default: () => ({}) },
        itemTitle: String,
        tabsTag: String,
        tabsAttrs: { type: Object, default: () => ({}) },
        tabTag: String,
        tabAttrs: { type: Object, default: () => ({}) },
        tabActive: String,
    },
    components: {
        Gnb,
    },
    data() {
        return {};
    },
};
</script>

<style lang="scss" scoped>
.sub-head {
    ::v-deep {
        .v-tab--active {
            pointer-events: none;
        }
    }

    &--with-header {
        margin-top: calc(var(--header-height) * -1);
        .sub-visual {
            padding-top: var(--header-height);
        }
    }
    &--with-tabs {
        position: relative;
        .sub-visual {
            padding-bottom: var(--tab-height-comfortable);
        }
        .sub-tab-wrap {
            position: absolute;
            bottom: 0;
            left: 50%;
            -webkit-transform: translate(-50%, 0);
            -ms-transform: translate(-50%, 0);
            transform: translate(-50%, 0);
            width: 100%;
        }
    }
    &--none-tabs {
        .sub-visual {
            padding-bottom: 0;
            &__inner {
                height: calc(var(--sub-visual-height) + var(--tab-height-comfortable));
            }
        }
    }
}

.sub-visual {
    position: relative;
    &__inner {
        display: flex;
        align-items: center;
        text-align: center;
        height: var(--sub-visual-height);
    }
    &__bg {
        position: absolute;
        top: 0;
        left: 50%;
        z-index: -1;
        -webkit-transform: translate(-50%, 0);
        -ms-transform: translate(-50%, 0);
        transform: translate(-50%, 0);
        width: 100vw;
        height: 100%;
        background-repeat: no-repeat;
        background-position: center;
        background-size: cover;
    }
}
@media (min-width: 576px) {
}
@media (min-width: 768px) {
}
@media (min-width: 1024px) {
}
@media (min-width: 1200px) {
}
</style>
